import React from "react";
import StepShell from "./StepShell";
import copy from "../copy";

const ThankYou = () => {
  const c = copy.thanks;
  return (
    <StepShell className="rp-thanks" title={c.title} subtitle={c.text}>
      <div className="rp-notice">
        <p>
          <span aria-hidden="true">⚠️ </span>
          <strong>{c.warningBold}</strong> {c.warning}
        </p>
      </div>
      <p className="rp-strong">{c.strong}</p>
    </StepShell>
  );
};

export default ThankYou;
